import { ScheduleDataObjectType } from "@opendash/schedule";
import { makeAutoObservable } from "mobx";
import { CronState } from "..";

export class StateProvider {
  private static state: CronState = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  public static getState(value?: ScheduleDataObjectType): CronState {
    if (typeof this.state === "undefined") {
      // this.state = new CronState(value);
    }
    return this.state;
  }

  public static resetState() {
    this.state = undefined;
  }
}
